import { useEffect, useState } from "react";
import { StepModalTemplate } from "templates/StepModalTemplate";
import { Tab } from "../../TabHeader";
import { ManualOccurrenceModalProps, occurrenceTabs } from "./data";
import { useManualOccurrence } from "contexts/register/ManualOccurrence";
import * as Tabs from "./Tabs";

import * as S from "./styles";
import { Flex } from "monk_ui";
import Loader from "./Loader";
import { TabWithAutoComplete } from "./TabWithAutoComplete";
import { useAuth } from "contexts/authContext";

export default function ManualOccurrenceModal({
  isOpen,
  setIsOpen,
  type,
}: ManualOccurrenceModalProps) {
  const [selectedTab, setSelectedTab] = useState<Tab | null>(null);
  const {role} = useAuth()
  const {
    occurrenceToEdit,
    lastSelectedTabLabel,
    setLastSelectedTabLabel,
    occurrenceType,
    isLoading,
    isFetching,
  } = useManualOccurrence();

  // variable to check if the occurrence in edit have policeman attached
  const hasPolicemanWorking =
    occurrenceToEdit.report &&
    occurrenceToEdit.report.length > 0 &&
    (occurrenceToEdit.report[0].superficialPoliceman ||
      occurrenceToEdit.policemen);

  // variable to store the modal tabs, if a policeman is already attached to the occurrence, remove the Policeman tab
  const tabs = hasPolicemanWorking
    ? occurrenceTabs[type].filter((item) => item.index !== 3)
    : occurrenceTabs[type];

  const patrimonialTabsToRemoveWhenIsOccurrenceFinished = role === 'master' ? [0, 5] : [0, 4, 5]
  const vehicleTabsToRemoveWhenIsOccurrenceFinished =  role === 'master' ? [0, 1, 8]: [0, 1, 7, 8];
  const isOccurrenceFinished = occurrenceToEdit.status === "concluido";

  const filteredTabsWhenOccurrenceIsFinished = tabs.filter((tab) =>
    occurrenceType === "patrimonial"
      ? !patrimonialTabsToRemoveWhenIsOccurrenceFinished.includes(tab.index)
      : !vehicleTabsToRemoveWhenIsOccurrenceFinished.includes(tab.index)
  );

  useEffect(() => {
    if (!lastSelectedTabLabel) {
      setSelectedTab(
        isOccurrenceFinished ? filteredTabsWhenOccurrenceIsFinished[0] : tabs[0]
      );
      return;
    }

    const lastTab = tabs.find((tab) => tab.text === lastSelectedTabLabel);

    if (
      patrimonialTabsToRemoveWhenIsOccurrenceFinished.includes(lastTab?.index!)
    )
      return;

    if (vehicleTabsToRemoveWhenIsOccurrenceFinished.includes(lastTab?.index!))
      return;

    setSelectedTab(lastTab!);
  }, [occurrenceToEdit]); // eslint-disable-line

  function handleSelectedTab(tab: Tab) {
    setSelectedTab(tab);
    setLastSelectedTabLabel(tab.text);
  }

  return (
    <StepModalTemplate
      deactivatedTabs={[]}
      title="Gerenciar ocorrência manual"
      buttonText="Efetuar cadastro"
      opened={isOpen}
      setOpened={() => {
        setIsOpen();
        setSelectedTab(tabs[0])
      }}
      sending={false}
      removeSubmitButton
      disableButton={false}
      invalidTabs={[]}
      tabs={isOccurrenceFinished ? filteredTabsWhenOccurrenceIsFinished : tabs}
      selectedTab={selectedTab ?? ({} as Tab)}
      setSelectedTab={(tab) => handleSelectedTab(tab)}
      handleSubmit={() => { }}
      hideFooter
      data-cy="step-modal"
    >
      {(isLoading || isFetching) && (
        <Flex
          width="100%"
          height="100%"
          alignItems="center"
          justifyContent="center"
        >
          <Loader size={60} color="#fff" />
        </Flex>
      )}
      {!isLoading && !isFetching && selectedTab && (
        <S.Container>
          {type === "patrimonial" && (
            <div>
              {selectedTab.index === 2 && <TabWithAutoComplete element={<Tabs.ArrivalTimeTab />} />}
              {selectedTab.index === 4 && <TabWithAutoComplete element={<Tabs.AttachmentsTab />} />}
              {selectedTab.index === 7 && <TabWithAutoComplete element={<Tabs.PaymentTab />} />}
              {selectedTab.index === 9 && <TabWithAutoComplete element={<Tabs.RouteViewTab />} />}
              {selectedTab.index === 0 && <Tabs.OccurrenceDataTab />}
              {selectedTab.index === 1 && <Tabs.OverviewTab />}
              {selectedTab.index === 3 && !hasPolicemanWorking && (
                <Tabs.PolicemanTab />
              )}
              {selectedTab.index === 5 && <Tabs.FinishTab />}
              {selectedTab.index === 6 && <Tabs.WhatsappTab />}
              {selectedTab.index === 8 && <Tabs.HistoryTab />}
              {selectedTab.index === 10 && (role === 'master' ? <Tabs.MasterCommentsTab />:<Tabs.CommentsTab />)}
              </div>
          )}

          {type === "vehicular" && (
            <div>
              {selectedTab.index === 4 && <Tabs.LastLocationsTab />}
              {selectedTab.index === 5 && <TabWithAutoComplete element={<Tabs.ArrivalTimeTab />} />}
              {selectedTab.index === 6 && <TabWithAutoComplete element={<Tabs.RouteViewTab />} />}
              {selectedTab.index === 7 && <TabWithAutoComplete element={<Tabs.AttachmentsTab />} />}
              {selectedTab.index === 10 && <TabWithAutoComplete element={<Tabs.PaymentTab />} />}
              {selectedTab.index === 0 && <Tabs.OccurrenceDataTab />}
              {selectedTab.index === 1 && <Tabs.VehicleDataTab />}
              {selectedTab.index === 2 && <Tabs.OverviewTab />}
              {selectedTab.index === 3 && !hasPolicemanWorking && (
                <Tabs.PolicemanTab />
              )}
              {selectedTab.index === 4 && <Tabs.LastLocationsTab />}
              {selectedTab.index === 8 && <Tabs.FinishTab />}
              {selectedTab.index === 9 && <Tabs.WhatsappTab />}
              {selectedTab.index === 11 && <Tabs.HistoryTab />}
              {selectedTab.index === 12 && (role === 'master' ? <Tabs.MasterCommentsTab />:<Tabs.CommentsTab />)}
              </div>
          )}
        </S.Container>
      )}
    </StepModalTemplate>
  );
}
